import { useTranslation } from "react-i18next";
import classes from "../../../../../assets/css/showCardInfo.module.css";
import icons from "../../../../../Data/icons";

const RulesDetalis = ({ Rules }) => {
  const { t } = useTranslation();

  const titles = {
    id: "#",
    name: t("Name"),
    slug: t("slug"),
    type: t("type"),
  };
  const IdCardIcon = icons.idCard;
  const AbcIcon = icons.abc;

  const { id, name, slug, type } = Rules;
  return (
    <div className={classes.container}>
      <div className={classes.tableCard}>
        <div className={classes.tableCardBody}>
          <ul className={classes.ListGroup}>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <IdCardIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.id}</h5>
                <p>{id}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <AbcIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.name}</h5>
                <p className={classes.listPargrah}>{name}</p>
              </div>
            </li>

            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <AbcIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.slug}</h5>
                <p className={classes.listPargrah}>{slug}</p>
              </div>
            </li>
            <li className={classes.listItemGroup}>
              <div className={classes.listIcon}>
                <AbcIcon />
              </div>
              <div>
                <h5 className={classes.listTitle}>{titles.type}</h5>
                <p className={classes.listPargrah}>{type}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RulesDetalis;
